<template>
  <v-navigation-drawer
    id="core-navigation-drawer"
    v-model="drawer"
    :dark="barColor !== 'rgba(228, 226, 226, 1), rgba(255, 255, 255, 0.7)'"
    :expand-on-hover="expandOnHover"
    :right="$vuetify.rtl"
    mobile-break-point="960"
    :src="barImage"
    app
    width="260"
    v-bind="$attrs"
  >
    <template v-slot:img="props">
      <v-img
        :gradient="`to bottom, ${barColor}`"
        v-bind="props"
      />
    </template>

    <v-list-item two-line>
      <v-list-item-content>
        <v-list-item-title class="posheader text-uppercase font-weight-regular display-2">
          <v-img
            src="../../../../assets/images/POSwhite.png"
            max-width="100"
          />
          <span class="logo-normal">{{ $t('Admin') }}</span>
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-divider class="mb-1" />

    <v-list
      expand
      nav
    >
      <!-- Style cascading bug  -->
      <!-- https://github.com/vuetifyjs/vuetify/pull/8574 -->
      <div />

       <div class="posLinkWrapper">
        <button
          class="logoutBtn"
          @click="_openBillPay"
        >
          Bill Pay
        </button>
      </div>

      <template v-for="(item, i) in computedItems">
        <base-item-group
          v-if="item.children"
          :key="`group-${i}`"
          :item="item"
        >
          <!--  -->
        </base-item-group>

        <base-item
          v-else
          :key="`item-${i}`"
          :item="item"
        />
      </template>

      <feedback-dialog labelText='Help and support' />

      <div />
    </v-list>
  </v-navigation-drawer>
</template>

<script>
  /* eslint-disable */
  // Utilities
  import {
    mapState
  } from 'vuex'

  export default {
    name: 'DashboardCoreDrawer',

    components: {
      FeedbackDialog: () => import('../../../../modules/private-module/components/feedback-dialog/feedback-dialog.vue'),
    },

    props: {
      expandOnHover: {
        type: Boolean,
        default: false
      }
    },

    data: () => ({
      items: [
        {
          icon: 'mdi-view-dashboard',
          title: 'dashboard',
          to: '/admin/dashboard'
        },
        {
          title: 'Patients',
          icon: 'mdi-clipboard-outline',
          to: '/admin/patients',
        },
        {
          title: 'Templates',
          icon: 'mdi-file-document',
          to: '/admin/manage-templates',
        },
        {
          title: 'Manage Groups',
          icon: 'mdi-account-multiple',
          to: '/admin/manage-groups',
        }
      ],
      userName: ''
    }),

    computed: {
      ...mapState(['barColor', 'barImage']),
      drawer: {
        get () {
          return this.$store.state.drawer
        },
        set (val) {
          this.$store.commit('SET_DRAWER', val)
        }
      },
      computedItems () {
        return this.items.map(this.mapItem)
      },
    },

    watch: {
      '$vuetify.breakpoint.smAndDown' (val) {
        this.$emit('update:expandOnHover', !val)
      }
    },

    methods: {
      mapItem (item) {
        return {
          ...item,
          children: item.children ? item.children.map(this.mapItem) : undefined,
          title: this.$t(item.title)
        }
      },
      _openBillPay () {
        window.open(process.env.VUE_APP_BILLPAY_URL, "_self").focus();
      }
    },
  }
</script>
<style lang="sass" scoped>
  @import '~vuetify/src/styles/tools/_rtl.sass'
  .posLinkWrapper
    margin-top: 25px
    margin-bottom: 25px
    .knowledgeBase
      padding: 25px 20px
      text-decoration: underline
      cursor: pointer
      text-align: center
    .logoutBtn
      border: 1px solid grey
      border-radius: 3px
      background-color: transparent
      width: 100%
      height: 40px
      display: flex
      justify-content: center
      align-items: center
  .posheader
    display: flex
    padding-top: 10px
    justify-content: space-evenly
    align-items: flex-end
    .v-image__image--cover
      background-size: contain!important
      margin-right: 15px
      margin-top: -9px

  #core-navigation-drawer
    &.v-navigation-drawer--mini-variant
      .v-list-item
        justify-content: flex-start !important

      .v-list-group--sub-group
        display: block !important

    .v-list-group__header.v-list-item--active:before
      opacity: .24

    .v-list-item
      &__icon--text,
      &__icon:first-child
        justify-content: center
        text-align: center
        width: 20px

        +ltr()
          margin-right: 24px
          margin-left: 12px !important

        +rtl()
          margin-left: 24px
          margin-right: 12px !important

    .v-list--dense
      .v-list-item
        &__icon--text,
        &__icon:first-child
          margin-top: 10px

    .v-list-group--sub-group
      .v-list-item
        +ltr()
          padding-left: 8px

        +rtl()
          padding-right: 8px

      .v-list-group__header
        +ltr()
          padding-right: 0

        +rtl()
          padding-right: 0

        .v-list-item__icon--text
          margin-top: 19px
          order: 0

        .v-list-group__header__prepend-icon
          order: 2

          +ltr()
            margin-right: 8px

          +rtl()
            margin-left: 8px
</style>
